﻿import * as React from 'react';
import { Spacer } from "../../../Spacer";
import Sweden from '../../../../../../../assets/images/flags/se.svg';
import Finland from '../../../../../../../assets/images/flags/fi.svg';
import France from '../../../../../../../assets/images/flags/fra.svg';
import Spain from '../../../../../../../assets/images/flags/spa.svg';

type ImpersonatedCountryFlagProps = {
    countryId: number;
};

function getCountryFlag(countryId: number) {
    switch (countryId) {
        case 1: {
            return Sweden;
        }
        case 2: {
            return Finland;
        }
        case 3: {
            return France;
        }
        case 4: {
            return Spain;
        }
    }
}

function ImpersonatedCountryFlag({ countryId }: ImpersonatedCountryFlagProps) {
    return (
        <>
            <img
                width="24"
                height="24"
                src={getCountryFlag(countryId)}
                alt="Active country"
            />
            <Spacer />
        </>
    )
}

export default ImpersonatedCountryFlag;
